import { EventEmitter } from "eventemitter3";
import { ERRORS, Listener, SupportHandlers } from "./type";
import { uuid } from "utils/common";
import { logDev } from "utils/logs";

abstract class BasePeripheral {
  /** ----- STATIC ---- */
  public static eventEmitter = new EventEmitter();

  protected mappingIdentifyInfo: Record<string, string> = {};

  public static register(key: keyof Window, event: SupportHandlers) {
    (window as any)[key] = (message: any) => {
      try {
        BasePeripheral.eventEmitter.emit(event, JSON.parse(message));
      } catch (error) {
        logDev({ error, message });
        alert(error?.toString());
      }
    };
  }
  /** ----- END STATIC ---- */

  protected abstract name: SupportHandlers;

  public abstract onResponse(callback: (data: any) => void): void;

  public abstract request(identify_info: string): void;

  public hasMessageHandlers(key: string) {
    return !!window.webkit?.messageHandlers[key];
  }

  public addListener(listener: Listener) {
    BasePeripheral.eventEmitter.on(this.name, (response) => {
      const identify_info = this.getIdentifyInfoById(response.identify_info);
      listener({ ...response, identify_info });
    });
  }

  protected callHandler(identify_info: string, payload?: Record<string, any>) {
    if (!this.hasMessageHandlers(this.name))
      throw new Error(ERRORS.CANNOT_CONNECT);

    const id = this.setIdentifyInfo(identify_info);
    logDev({ id, identify_info });

    this.postMessage({ ...payload, identify_info: id });
  }

  /**
   * Set the identify info for the response
   * @param identify_info
   * @returns id
   */
  private setIdentifyInfo(identify_info: string) {
    const id = uuid();

    this.mappingIdentifyInfo[id] = identify_info;

    return id;
  }

  private getIdentifyInfoById(id: string) {
    return this.mappingIdentifyInfo[id];
  }

  private postMessage(payload?: Record<string, any>) {
    return window.webkit?.messageHandlers[this.name]!.postMessage(
      JSON.stringify(payload)
    );
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default BasePeripheral;
